import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchSubscriptionUrlByEventId = async (token, eventId) => {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(searchParams);

  const config = {
    headers: { Authorization: `Token ${token}` },
  };
  let service_type = "Daily";
  if(eventId === 34) {
    service_type = "Daily";
  }else if(eventId === 149){
    service_type = "BCS";
  }else if(eventId === 75){
    service_type = "Sports";
  }else{
    service_type = "Tournament";
  }

  const res = await axios
    .post(
      `${baseUrl}/subscription/create/`,
      { portal: portal, qcid: sessionStorage.getItem("cid"), "service_type": service_type, ...paramsObject },
      config
    )
  return res.data;
}